import { AutogenModelCopyControl, AutogenRowCopyControl } from "./autogen/AutogenModelCopyControl";

export class ModelCopyControl extends AutogenModelCopyControl<RowCopyControl> {
    constructor() {
        super(RowCopyControl);
    }
}

export class RowCopyControl extends AutogenRowCopyControl {
}